import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import type { SecurityProfile } from './RolesPermissionsList';

interface EditRoleProfileProps {
  role: SecurityProfile;
  onBack: () => void;
  children: React.ReactNode;
}

export function EditRoleProfile({ role, onBack, children }: EditRoleProfileProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={onBack} className="shrink-0">
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div className="flex items-center gap-3 flex-1">
          <Shield className="h-5 w-5 text-primary" />
          <div>
            <h2 className="text-xl font-semibold">{role.name}</h2>
            <p className="text-sm text-muted-foreground">{role.description}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={role.isActive ? 'default' : 'secondary'}>
            {role.isActive ? 'Active' : 'Inactive'}
          </Badge>
          <Badge variant="outline" className="text-xs">
            {role.isSystem ? 'Platform' : 'Custom'}
          </Badge>
        </div>
      </div>

      {children}
    </div>
  );
}
